const legs = [
  {
    code: 'ST-01',
    name: 'Install',
    happens:
      'Your organization receives Compound — the evolving skill system — and wires it into the Cursor workspace where engineers already work.',
    receives:
      'A ready method layer: skills, orchestration patterns, and the memory model primed for your first product traverse.',
  },
  {
    code: 'ST-02',
    name: 'Adopt',
    happens:
      'The team runs real work through Compound — analysis, delivery, engineering, QA, security, and content — under senior review on every merge.',
    receives:
      'Working memory that survives sessions, plus the first durable project facts settling into place.',
  },
  {
    code: 'ST-03',
    name: 'Deepen',
    happens:
      'Each subsequent run sharpens project and institutional memory. Monthly skill drops keep the method current while your terrain grows denser.',
    receives:
      'A system increasingly fitted to this codebase — faster, more precise, covering the full SDLC without resetting context every sprint.',
  },
]

export function CompoundTraverse() {
  return (
    <section id="traverse" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="mb-8 flex flex-col gap-2 border-b-2 border-ink pb-4 sm:flex-row sm:items-end sm:justify-between">
          <h2 className="section-title text-ink">How Compound runs</h2>
          <p className="text-sm leading-relaxed text-ink-muted sm:max-w-sm sm:text-right">
            One traverse from install to a method that fits your ground.
          </p>
        </div>

        <div className="relative">
          <div
            className="absolute bottom-4 left-[1.125rem] top-4 w-px bg-ink lg:left-8"
            aria-hidden="true"
          />
          <div
            className="absolute bottom-4 left-[1.125rem] top-4 w-px border-l border-dashed border-overprint lg:left-8"
            aria-hidden="true"
          />

          <ol className="space-y-0">
            {legs.map((leg) => (
              <li
                key={leg.code}
                className="relative grid gap-4 py-6 pl-12 lg:grid-cols-[10rem_1fr_1fr] lg:gap-10 lg:py-7 lg:pl-20"
              >
                <span
                  className="absolute left-[0.55rem] top-8 flex h-5 w-5 items-center justify-center rounded-full border-[1.5px] border-ink bg-sheet lg:left-[1.45rem] lg:top-9"
                  aria-hidden="true"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-overprint" />
                </span>

                <div>
                  <span className="datum block text-overprint">{leg.code}</span>
                  <h3
                    className="entry-title mt-1.5 text-ink"
                    style={{ fontStretch: '80%' }}
                  >
                    {leg.name}
                  </h3>
                </div>

                <div>
                  <p className="cell-label mb-2 text-ink-muted">What happens</p>
                  <p className="text-[0.9375rem] leading-relaxed text-ink-muted">
                    {leg.happens}
                  </p>
                </div>

                <div>
                  <p className="cell-label mb-2 text-ink-muted">What you receive</p>
                  <p className="text-[0.9375rem] leading-relaxed text-ink-muted">
                    {leg.receives}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
